import { toApiNullablePhoneNumber } from 'src/common/validation/converters/phone';
import type { IContact } from 'src/types/IContact';

export function toApiContact(contact: IContact): IContact {
  // Avoid unnecessary fields from `...contact`
  return {
    id: contact.id,
    contactType: contact.contactType,
    firstName: contact.firstName,
    lastName: contact.lastName,
    emailAddress: contact.emailAddress,

    plainPhone: toApiNullablePhoneNumber(contact.plainPhone),
    plainPhoneExt: contact.plainPhoneExt || null,
    cellPhone: toApiNullablePhoneNumber(contact.cellPhone),
  };
}
